import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang, pick } from "../i18n/LanguageContext";
import { t } from "../i18n/translations";
import { seoPage } from "../data/seo";

// Päivittää välilehden otsikon ja meta descriptionin reitin ja kielen mukaan.
// html lang -attribuutin asettaa LanguageProvider. Ensilatauksen tagit (myös
// og- ja canonical) tulevat valmiina scripts/write-route-meta.mjs:n
// kirjoittamasta reittikohtaisesta index.html:stä.
const PageMeta = () => {
  const { pathname } = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    const tr = pick(lang);
    const meta = t.meta[seoPage(pathname).key];
    document.title = tr(meta.title);
    let desc = document.head.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", tr(meta.description));
  }, [pathname, lang]);

  return null;
};

export default PageMeta;
